export function savings(continuedSpend: number, plannedSpend: number) {
  return continuedSpend - plannedSpend;
}

export function savingsPercentage(
  continuedSpend: number,
  plannedSpend: number,
) {
  return percentage(continuedSpend - plannedSpend, continuedSpend);
}

export function percentage(numerator: number, denominator: number) {
  function notAValidDivisor(value: any): boolean {
    return value === 0 || value == null;
  }

  return notAValidDivisor(denominator)
    ? 0
    : (numerator / denominator) * 100;
}

export function savingsCeilingPercentage(
  continuedSpend: number,
  plannedSpend: number,
) {
  return ceilingPercentage(continuedSpend - plannedSpend, continuedSpend);
}

export function ceilingPercentage(numerator: number, denominator: number) {
  return denominator ? Math.ceil((numerator / denominator) * 100) : 0;
}

